$( document ).ready(function() {
    $('.awardes-section .wrapper').slick({
      infinite: false,
      slidesToShow: 3,
      slidesToScroll: 1,
      arrows: false,
      responsive: [
        {
          breakpoint: 990,
          settings: {
            infinite: true,
            slidesToShow: 2,
            slidesToScroll: 1,
            dots: false
          }
        },
        {
          breakpoint: 768,
          settings: {
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: false
          }
        }
      ]
    });

      $(".shopify-live-chat .rich-text__buttons .btn-rounded-comman").on('click', function (event) {
        //event.preventDefault();
          console.log('dddd');
       document.querySelector('#ShopifyChat').click();
      });



});